module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Preface"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "sec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rsec2"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("I’ve noted that many paleontologists seem to have the same origin story: a childhood interest in fossils that never ended, and parents who were supportive of these endeavors (once they finally accepted that it was not a phase). In that respect, I’m no different from all the others. People always ask me when my interest in dinosaurs began, but in all honesty, it began so early in my childhood that I can’t remember that far back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("I suppose what makes me different is my interest in one particular subject. While I’ve always been interested in dinosaurs, my fascination with North Africa is a relatively new development. And contrary to what some might be thinking because of my name, it has nothing to do with being of Moroccan descent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("It was in early 2008; I was attending university at the time. My mother had purchased Nothdurft’s book "), _c('i', [_vm._v("The Lost Dinosaurs of Egypt")]), _vm._v(" for me the previous Christmas, and I was finally getting around to reading it. It was the closest I’ve ever come to a religious conversion. I stayed up into the night, finishing the book from cover to cover in one go—undoubtedly the highest compliment you can give a book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("I was enthralled: the adventures, the larger-than-life characters who preceded me, the absolute uniqueness of the environment. The more data I collected, the more my love of North African paleontology was fueled. From that moment, I dedicated my life to the paleontology of North Africa, and I’ve never looked back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This book is just one further manifestation of my love for this topic. A definitive book on North African paleontology is long overdue. One inspiration was "), _c('i', [_vm._v("Jurassic West")]), _vm._v(" by John Foster. No doubt readers will immediately see the similarities in style as I attempt to do for Africa what Foster did for the US.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This project has been a four-year labor of love. It hasn’t all been easy to write; some days I’ll write three or four pages at a go, and other days I stare at a blank screen, wondering where to begin. I also seem to have developed a habit of writing chapters in no particular order, instead of starting at the beginning; whether other authors use this style or this is just a quirk of my own, I can’t say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Ultimately, my aim with this work is to produce something informal and accessible, yet also to provide a serious scientific discourse that will hopefully become a reference source for the paleontological community for years to come. And even if you don’t pay me that ultimate compliment by finishing this book from cover to cover in one go, I hope with all my "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_vm._v("heart that you will come away having learned something new. As Kenneth Lacovara once said, ancient North Africa “was a huge biome, one that is only just beginning to be explored.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("So let’s explore it together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_c('i', [_vm._v("Jamale Ijouiher, July 2022.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba7fc54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Preface.vue
// module id = 81
// module chunks = 0